import React from 'react';
import InteractiveField from '../common/InteractiveField';
import MultilineField from '../common/MultilineField';
import '../../styles/Signatures.css';

const PartyRequisites = ({ title, partyData, onPartyChange, showValidation = false, validationIds = {} }) => {
    
    const handleFieldChange = (field, value) => {
        onPartyChange({ ...partyData, [field]: value });
    };

    return (
        <div className="party-requisites">
            <h4>{title}</h4>
            <div className="requisites-grid">
                <span>Ф.И.О.</span>
                <InteractiveField
                    value={partyData?.fullName || ''}
                    onChange={(val) => handleFieldChange('fullName', val)}
                    placeholder="Ф.И.О. полностью"
                    fullWidth={true}
                    isRequired={true}
                    showValidation={showValidation}
                    validationFieldId={validationIds.fullName}
                />

                <span>Адрес проживания</span>
                <InteractiveField
                    value={partyData?.address || ''}
                    onChange={(val) => handleFieldChange('address', val)}
                    placeholder="г. Москва, ул. Ленина, д. 1, кв. 1"
                    fullWidth={true}
                    isRequired={true}
                    showValidation={showValidation}
                    validationFieldId={validationIds.address}
                />

                <span>Паспорт РФ: серия и №</span>
                <div className="passport-inline">
                    <InteractiveField
                        value={partyData?.passportSerial || ''}
                        onChange={(val) => handleFieldChange('passportSerial', val)}
                        placeholder="4509"
                        className="passport-serial-mask"
                    />
                    <span className="passport-divider">№</span>
                    <InteractiveField
                        value={partyData?.passportNumber || ''}
                        onChange={(val) => handleFieldChange('passportNumber', val)}
                        placeholder="123456"
                        className="passport-number-mask"
                    />
                </div>

                <span>выдан</span>
                <InteractiveField
                    value={partyData?.passportIssuedBy || ''}
                    onChange={(val) => handleFieldChange('passportIssuedBy', val)}
                    placeholder="ГУ МВД России по г. Москве"
                    fullWidth={true}
                />

                <span>дата выдачи</span>
                 <InteractiveField
                    value={partyData?.passportIssueDate || ''}
                    onChange={(val) => handleFieldChange('passportIssueDate', val)}
                    placeholder="01.01.2024"
                    type="text"
                    className="date-mask"
                    fullWidth={true}
                />

                <span>код подразделения</span>
                <InteractiveField
                    value={partyData?.passportDeptCode || ''}
                    onChange={(val) => handleFieldChange('passportDeptCode', val)}
                    placeholder="770-001"
                    className="dept-code-mask"
                />
                
                <span>Телефон</span>
                <InteractiveField
                    value={partyData?.phone || ''}
                    onChange={(val) => handleFieldChange('phone', val)}
                    placeholder="+7 (999) 123-45-67"
                    className="phone-mask"
                    fullWidth={true}
                    isRequired={true}
                    showValidation={showValidation}
                    validationFieldId={validationIds.phone}
                />

                <span className="optional-field">Адрес электронной почты
                    <span className="optional-hint">необязательно</span>
                </span>
                <InteractiveField
                    value={partyData?.email || ''}
                    onChange={(val) => handleFieldChange('email', val)}
                    placeholder="ivanov@email.com"
                    fullWidth={true}
                />

                <span>Платежные реквизиты</span>
                <MultilineField
                    value={partyData?.paymentDetails || ''}
                    onChange={(val) => handleFieldChange('paymentDetails', val)}
                    placeholder="Карта Сбербанк 1234 5678 9012 3456"
                    minRows={1}
                    maxRows={5}
                />
            </div>
        </div>
    );
};


const SignaturesSection = ({ data, onChange, showValidation = false, fullData }) => {
    
    const handleLandlordChange = (newData) => {
        const updatedData = { ...data, landlord: newData };
        
        // Синхронизация ФИО и паспортных данных с преамбулой договора
        if (fullData) {
            const parties = fullData.parties || {};
            updatedData.parties = {
                ...parties,
                landlordName: newData.fullName ?? parties.landlordName ?? '',
                landlordPassportSerial: newData.passportSerial ?? parties.landlordPassportSerial ?? '',
                landlordPassportNumber: newData.passportNumber ?? parties.landlordPassportNumber ?? ''
            };
        }
        
        onChange(updatedData);
    };

    const handleTenantChange = (newData) => {
        const updatedData = { ...data, tenant: newData };
        
        // Синхронизация ФИО и паспортных данных с преамбулой договора
        if (fullData) {
            const parties = fullData.parties || {};
            updatedData.parties = {
                ...parties,
                tenantName: newData.fullName ?? parties.tenantName ?? '',
                tenantPassportSerial: newData.passportSerial ?? parties.tenantPassportSerial ?? '',
                tenantPassportNumber: newData.passportNumber ?? parties.tenantPassportNumber ?? ''
            };
        }
        
        onChange(updatedData);
    };

    return (
        <div className="signatures-section">
            <h2 className="special-section-title">10. Адреса и реквизиты Сторон</h2>
            
            {/* Информационное сообщение о паспортных данных и платежных реквизитах */}
            <p style={{ fontStyle: 'italic', color: 'var(--text-secondary)', background: 'var(--bg-subtle)', padding: '12px', borderRadius: '8px', marginBottom: '16px', marginTop: '12px' }}>
                *Паспортные данные и платежные реквизиты могут быть оставлены пустыми. Вы можете заполнить их позже после скачивания договора или непосредственно на бумаге.
            </p>
            
            <div className="parties-container">
                <PartyRequisites
                    title="Наймодатель"
                    partyData={data?.landlord}
                    onPartyChange={handleLandlordChange}
                    showValidation={showValidation}
                    validationIds={{
                        fullName: 'signatures-landlordFullName',
                        address: 'signatures-landlordAddress',
                        phone: 'signatures-landlordPhone'
                    }}
                />
                <PartyRequisites
                    title="Наниматель"
                    partyData={data?.tenant}
                    onPartyChange={handleTenantChange}
                    showValidation={showValidation}
                    validationIds={{
                        fullName: 'signatures-tenantFullName',
                        address: 'signatures-tenantAddress',
                        phone: 'signatures-tenantPhone'
                    }}
                />
            </div>
        </div>
    );
};

export default SignaturesSection;
